import { axiosOrderInstance } from "config";
import {
  OrderFormElementCategory,
  OrderFormElementRoute,
  OrderFormElementType,
} from "enums";
import { useAxiosQuery } from "hooks";

type UseOrderQueueProps = {
  encounterId: string;
  enabled?: boolean;
};

type OrderQueueItem = {
  id: string;
  orderBy: string;
  description: string;
  notes?: string;
  elementId?: string;
  elementContent?: string;
  elementType: OrderFormElementType;
  elementCategory?: OrderFormElementCategory;
  location?: string;
  route?: OrderFormElementRoute;
  administrationTime?: string;
  cptCode?: string;
  studyTypeId?: string;
  instructions?: string;
  encounterId: string;
  chartApplicationId: string;
  scheduledTime?: string;
  scheduleNow?: boolean;
  isObservation?: boolean;
  isScheduled?: boolean;
  isPRN?: boolean;
  prnReason?: string;
  repetitions?: number;
  repetitionHours?: number;
  repetitionMinutes?: number;
  createdAt: Date;
};

function useOrderQueue({ encounterId, enabled }: UseOrderQueueProps) {
  return useAxiosQuery(
    ["orderQueue", { encounterId }],
    () => axiosOrderInstance.get<OrderQueueItem[]>(`v1/queue/${encounterId}`),
    { enabled }
  );
}

export type { OrderQueueItem };
export { useOrderQueue };
